import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import type {
  GetCurrentUserQuery,
  GetCurrentUserQueryVariables,
  GetMyHiveOnboardingProgressQuery,
  GetMyHiveOnboardingProgressQueryVariables,
  SetMyHiveOnboardingProgressMutation,
  SetMyHiveOnboardingProgressMutationVariables,
  TrackUserSeenMutation,
  TrackUserSeenMutationVariables,
  UpdateUserMutation,
  UpdateUserMutationVariables,
} from '@/__generated__/graphql';

export const GET_CURRENT_USER: TypedDocumentNode<GetCurrentUserQuery, GetCurrentUserQueryVariables> = gql`
  query GetCurrentUser {
    getCurrentUser {
      id
      firstName
      lastName
      email
      role
      avatarUrl
      tagline
      language
      bio
      organizationName
      portfolioId
      reportingOnboard
      phone
      jobTitle
    }
  }
`;

export const UPDATE_USER: TypedDocumentNode<UpdateUserMutation, UpdateUserMutationVariables> = gql`
  mutation UpdateUser($input: UpdateUserInput!) {
    updateUser(input: $input)
  }
`;

export const TRACK_USER_SEEN: TypedDocumentNode<TrackUserSeenMutation, TrackUserSeenMutationVariables> = gql`
  mutation TrackUserSeen {
    trackUserSeen
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input)
  }
`;

export const LIST_USERS = gql`
  query ListUsers($skip: Float, $take: Float, $search: String, $role: String) {
    listUsers(skip: $skip, take: $take, search: $search, role: $role) {
      id
      firstName
      lastName
      email
      role
      mobilePhone
      language
      slackMemberId
      managedPages {
        pageId
        mainContact
        page {
          id
          title
          streetAddress
          slug
          profilePic
        }
      }
    }
  }
`;

export const GET_USER_REGISTERED_EVENTS = gql`
  query GetUserRegisteredEvents {
    getUserRegisteredEvents
  }
`;

export const REGISTER_FOR_EVENT = gql`
  mutation RegisterForEvent($input: RegisterEventInput!) {
    registerForEvent(input: $input)
  }
`;

export const UNREGISTER_FROM_EVENT = gql`
  mutation UnregisterFromEvent($input: UnregisterEventInput!) {
    unregisterFromEvent(input: $input)
  }
`;

export const GET_MYHIVE_ONBOARDING: TypedDocumentNode<
  GetMyHiveOnboardingProgressQuery,
  GetMyHiveOnboardingProgressQueryVariables
> = gql`
  query GetMyHiveOnboardingProgress($pageId: String!) {
    getMyHiveOnboardingProgress(pageId: $pageId) {
      activeFlow
      completedFlows
      seen
      updatedAt
      numberOfWorkshopsBookedThisYear
      contractedWorkshops
      sharedPageWithTenantsAt
      cohort
      startedAt
    }
  }
`;

export const SET_MYHIVE_ONBOARDING: TypedDocumentNode<
  SetMyHiveOnboardingProgressMutation,
  SetMyHiveOnboardingProgressMutationVariables
> = gql`
  mutation SetMyHiveOnboardingProgress($progress: UpdateMyHiveOnboardingInput!) {
    setMyHiveOnboardingProgress(progress: $progress)
  }
`;
